/// <summary>
/// This object is a generalization of the vcTemplate to send an Email <br/>
/// It is basically an extraction from the SendEmail Widget in the Intervention
/// Author: MWI/AFU<br />
/// Date: 14.01.2016<br />
/// Copyright ©: EUDT GmbH 2016 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 14.01.2016                                               *<br />
/// **********************************************************************<br />
/// * -  inherited from template.js and the SendEmail widget             *<br />
/// * -  basically just adds a function for the Back Button              *<br />
/// **********************************************************************<br />
/// </summary>

function sendEmailGallery() { }
sendEmailGallery.prototype = new window.sendEmail();

sendEmailGallery.prototype.init = function () {
    var me = this;
    try {
        window.sendEmail.prototype.init.call(this);
        me.visual.find('#btnBackEmail').button().off("click").on("click", function () {
            $('#selNewWidget').removeClass("ui-selected");
            window._VCMQ.produce(me.visual, me.vcgid, 'GALMEN_LOAD', null);
           
        });
        

      

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};

// ReSharper disable once UnusedParameter
sendEmailGallery.prototype.doEvent = function (event) { };
